import { Reveal } from "@/components/Reveal";

const XL_COLS = { 4: "xl:grid-cols-4", 5: "xl:grid-cols-5" };

/**
 * Ablauf als Kartenreihe. Einheitlich auf Startseite und beiden
 * Zielgruppenseiten. `steps`: { no, title, text, optional? }. Bis fünf
 * Schritte stehen ab xl in einer Reihe, sechs in zwei Reihen zu je drei.
 */
export const Steps = ({ steps }) => (
  <div
    className={`grid gap-5 md:gap-6 sm:grid-cols-2 lg:grid-cols-3 ${
      XL_COLS[steps.length] || ""
    }`}
  >
    {steps.map((s, i) => (
      <Reveal key={s.no} delay={i * 0.07}>
        <div className="group relative h-full overflow-hidden rounded-3xl border border-white/10 backdrop-blur-xl p-8 hover:border-white/20 transition-colors duration-500">
          <div className="absolute -right-3 -top-6 font-display font-black text-[6rem] leading-none text-white/[0.03] group-hover:text-white/[0.06] transition-colors duration-500 select-none">
            {s.no}
          </div>
          <div className="relative">
            <h3 className="flex flex-wrap items-center gap-x-2.5 gap-y-1 font-display font-bold text-xl text-white mb-3">
              {s.title}
              {s.optional && (
                <span className="rounded-full border border-white/10 px-2.5 py-0.5 font-sans text-[10px] uppercase tracking-[0.15em] font-bold text-white/45">
                  optional
                </span>
              )}
            </h3>
            <p className="text-sm leading-relaxed text-white/55">{s.text}</p>
          </div>
          <div className="absolute bottom-0 left-0 h-1 w-0 bg-gradient-to-r from-brand-orange to-brand-blue group-hover:w-full transition-all duration-700" />
        </div>
      </Reveal>
    ))}
  </div>
);
